import { RefObject } from "react";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { useNotification, useTranslate } from "@refinedev/core";

import { ModalRef } from "@shared/components";
import { useCreateMagazineTemplateMutation } from "@modules/magazineTemplates/services/mutations";
import { MagazineTemplateFormValues, magazineTemplateSchema } from "@modules/magazineTemplates/validations";

export function useCreateMagazineTemplateModal(modalRef: RefObject<ModalRef>, onComplete?: () => void) {
  const translate = useTranslate();
  const { open } = useNotification();

  const methods = useForm<MagazineTemplateFormValues>({
    resolver: zodResolver(magazineTemplateSchema()),
    mode: "onBlur",
    defaultValues: {
      article_content: "Todo mês novas reportagens e dicas de benefícios exclusivas!",
    },
  });

  const { mutateAsync, isPending } = useCreateMagazineTemplateMutation({
    onSuccess: () => {
      onComplete?.();
      open?.({
        type: "success",
        message: translate("magazine/magazine_template_admin.success.create"),
      });

      modalRef.current?.close();
    },
  });


  return {
    methods,
    mutateAsync,
    isPending,
  };
}
